<template>
  <div class="checkbox-all d-flex align-center ga-1">
    <div :data-column="params.column.getColId()">
      <v-checkbox v-model="checkedAll" hide-details density="compact" @update:model-value="onCheckAllChange"></v-checkbox>
    </div>
    <span>{{ params.displayName }}</span>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useControlStore } from "@/stores/controlStore";

const { params } = defineProps(["params"]);

const controlStore = useControlStore();
const checkedAll = ref(false);

function onCheckAllChange(isChecked) {
  controlStore.checkAll(params.api, params.column.getColId(), !!isChecked);
}
</script>
